export const questions = [
  {
    id: 1,
    section: "Executive Summary",
    question: "In 2-3 sentences, describe: What are you building? Who is it for? What problem does it solve?",
    placeholder: "Example: We're building a real-time sales performance dashboard for sales managers at mid-size B2B companies (50-200 employees). It solves the problem of managers spending 5 hours per week manually compiling reports from multiple systems...",
    tip: "Be specific! Include WHO it's for, WHAT you're building, and WHAT PROBLEM it solves."
  },
  {
    id: 2,
    section: "Problem Statement",
    question: "Describe a specific scenario of a user experiencing the problem today. Include who they are, what they're doing, and why it's painful.",
    placeholder: "Example: Sarah, a sales manager with 8 reps, starts every Monday at 8:30am pulling CSVs from Salesforce and our call system. She spends 2 hours combining data in Excel...",
    tip: "Tell a story! Use a real person's name, describe their exact actions, and show the pain."
  },
  {
    id: 3,
    section: "Goals and Success Metrics",
    question: "What is your #1 measurable goal? Include the specific metric, target number, and how you'll measure it.",
    placeholder: "Example: Reduce time spent on weekly reporting from 5 hours to 30 minutes (90% reduction). We'll measure this through monthly surveys asking 'How much time did you spend compiling sales reports this week?'",
    tip: "Must be measurable! Include current state, target state, and HOW you'll measure it."
  },
  {
    id: 4,
    section: "Target Users",
    question: "Who is your primary user? Be very specific about their role, experience level, team size, and key characteristics.",
    placeholder: "Example: Sales managers with 2+ years of management experience, managing teams of 5-15 reps, at B2B SaaS companies with 50-500 employees. They're moderately tech-savvy, extremely busy (30+ meetings per week)...",
    tip: "Paint a clear picture! Include experience level, team size, tech savviness, work style."
  },
  {
    id: 5,
    section: "User Stories",
    question: "Describe the top 3 ways users will interact with this product. Use the format: 'As a [user], I want to [action], so that [benefit]'",
    placeholder: "Example: 1) As a sales manager, I want to see my team's revenue, activity, and win rate when I open the app, so I can assess team health in 30 seconds before standup. 2) As a sales manager...",
    tip: "Use the 'As a... I want to... so that...' format. Focus on the top 3 most important interactions."
  },
  {
    id: 6,
    section: "Scope",
    question: "List what you ARE building (top 5 features) and what you are NOT building (3-5 things explicitly out of scope).",
    placeholder: "Example: IN SCOPE: 1) Real-time dashboard with key metrics, 2) Team performance view, 3) Individual rep drill-down... OUT OF SCOPE: 1) Custom report builder, 2) Data export features...",
    tip: "Be explicit about both! What's IN and what's OUT. This prevents scope creep."
  },
  {
    id: 7,
    section: "Functional Requirements",
    question: "What MUST the product do to be considered working? List the core functionality (minimum 5 items).",
    placeholder: "Example: 1) Display total team revenue, calls made, meetings booked, and win rate for selected time period, 2) Show list of all reps with their individual metrics, 3) Allow clicking on any rep to see detailed breakdown...",
    tip: "Focus on MUST-HAVES only. What's the minimum viable product?"
  },
  {
    id: 8,
    section: "User Experience",
    question: "What should users see when they first open the product? Describe the main screen layout and how users navigate.",
    placeholder: "Example: Users see 4 large metric cards at the top: Total Team Revenue, Total Calls This Week, Win Rate, Deals Closing This Week. Below that is a table showing all reps with columns for name, revenue, calls...",
    tip: "Describe the visual layout! What's at the top, what's below, how do users move around?"
  },
  {
    id: 9,
    section: "Technical Requirements",
    question: "What systems must this integrate with? What are the key technical constraints (performance, security, platforms)?",
    placeholder: "Example: INTEGRATIONS: 1) Salesforce (deal data via REST API), 2) Outreach.io (activity data). PERFORMANCE: Page load under 3 seconds. SECURITY: Role-based access, data encrypted...",
    tip: "Include integrations, performance needs, security requirements, and platform support."
  },
  {
    id: 10,
    section: "Timeline",
    question: "When does this need to launch? What are the key milestones and any critical date constraints?",
    placeholder: "Example: LAUNCH DATE: May 15, 2026. MILESTONES: Design complete by March 1, API integrations by March 15, Core dashboard by April 1...",
    tip: "Include launch date, key milestones with dates, and any dependencies or constraints."
  },
  {
    id: 11,
    section: "Risks and Mitigations",
    question: "What are the top 3 things that could go wrong (technical, timeline, or adoption risks)? For each, what's your plan to prevent or handle it?",
    placeholder: "Example: RISK 1: Salesforce API integration delayed (30% likely) - MITIGATION: Start API work immediately, have manual CSV upload as fallback...",
    tip: "Be honest about risks! For each, include likelihood and your mitigation plan."
  },
  {
    id: 12,
    section: "Supporting Information",
    question: "What research supports this PRD? Who are the key stakeholders? What's the business case (investment vs. return)?",
    placeholder: "Example: RESEARCH: User interviews with 12 managers, survey of all 47 managers. STAKEHOLDERS: Sponsor: VP Sales (Jane Smith). BUSINESS CASE: Investment: $150K, Return: $200K+ annual benefit...",
    tip: "Include research done, key stakeholders with names/roles, and the business case with numbers."
  }
];